/** Saves a blob under `filename` via a transient object URL. */
export const triggerBlobDownload = (blob: Blob, filename: string): void => {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
};

/**
 * `responseType: 'blob'` applies to error responses too, so a JSON error
 * envelope arrives as a Blob and has to be unwrapped before it can be read.
 */
export const readBlobErrorMessage = async (blob: Blob): Promise<string> => {
    try {
        const text = await blob.text();
        const parsed: unknown = JSON.parse(text);
        if (typeof parsed === 'string') return parsed;
        const envelope = parsed as { detail?: unknown; message?: unknown; error_message?: unknown };
        for (const candidate of [envelope?.detail, envelope?.message, envelope?.error_message]) {
            if (typeof candidate === 'string' && candidate) return candidate;
        }
        return '';
    } catch {
        return '';
    }
};
